import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppService } from '../../app.service';

@Component({
  selector: 'site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class SiteHeaderComponent implements OnInit {
  public assessmentSiteUrl: string = '';
  initials: string = '';
  public isTeamLeader: boolean = false;
  public isElevateTeam: boolean = false;
  constructor(
    private appService: AppService,
    private Http: HttpClient,
  ) {}

  ngOnInit() {
    var currentUser = this.appService.getCurrentTeamMember();
    this.isTeamLeader = currentUser.isTeamLeader;
    this.initials = currentUser.initials;
    this.assessmentSiteUrl = this.appService.assessmentSiteBaseUrl;

    if (this.appService.getTeamInfo().isElevateTeam) {
      this.isElevateTeam = true;
      sessionStorage.setItem('elevateRedirectUrl', this.appService.getTeamInfo().redirectUrl);
    }
  }

  signOut() {
    sessionStorage.clear();
    window.location.href = '/api/session/signout';
    return false;
  }

  openAccount() {
    this.Http.get('/api/session/partialsignout').subscribe(() => {
      window.location.href = this.assessmentSiteUrl + '/MyAccount/Teams';
    });
  }

  billingHistory() {
    window.location.href = this.assessmentSiteUrl + '/MyAccount/BillingHistory';
    return false;
  }

  backToElevate() {
    this.Http.get('/api/session/partialsignout').subscribe(() => {
      window.location.href = sessionStorage.getItem('elevateRedirectUrl') || '';
    });
  }
}
